import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    min-height: 100dvh;
    background-color: var(--sds-color-background-default-default);
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-body);
    box-sizing: border-box;
  }

  * {
    box-sizing: border-box;
  }

  .container {
    width: 100%;
    max-width: 393px;
    margin: 0 auto;
    padding: var(--sds-size-space-800);
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
    box-sizing: border-box;
  }

  .logo {
    margin-bottom: var(--sds-size-space-800);
  }

  .content {
    background-color: var(--sds-color-background-neutral-strong);
    padding: var(--sds-size-space-800) var(--sds-size-space-500);
    border-radius: var(--sds-size-border-radius-200);
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
    align-items: center;
    box-sizing: border-box;
  }

  .success-header {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-200);
  }

  .title {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-06) / 1.2 var(--sds-typography-family-title);
    color: var(--sds-color-text-default-inverse);
    margin: 0;
  }

  .subtitle {
    font-family: var(--sds-typography-family-body);
    font-weight: var(--sds-typography-weight-regular);
    font-size: var(--sds-typography-scale-03);
    line-height: 1.5;
    color: var(--sds-color-text-default-inverse);
    margin: 0;
  }

  .verification-section {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-300);
    width: 100%;
    text-align: left;
    padding: var(--sds-size-space-400);
    background-color: var(--sds-color-background-default-default);
    border-radius: var(--sds-size-border-radius-100);
  }

  .section-title {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-04) / 1.3 var(--sds-typography-family-title);
    color: var(--sds-color-text-default-inverse);
    margin: 0;
  }

  .section-text {
    font-family: var(--sds-typography-family-body);
    font-weight: var(--sds-typography-weight-regular);
    font-size: var(--sds-typography-scale-02);
    line-height: 1.5;
    color: var(--sds-color-text-default-inverse);
    margin: 0;
  }

  .requirements-list {
    margin: 0;
    color: var(--sds-color-text-default-inverse);
    font-family: var(--sds-typography-family-body);
    font-weight: var(--sds-typography-weight-regular);
    font-size: var(--sds-typography-scale-02);
    line-height: 1.8;
  }

  .requirements-list li {
    margin-bottom: var(--sds-size-space-100);
  }

  .quick-note {
    font-family: var(--sds-typography-family-body);
    font-weight: var(--sds-typography-weight-regular);
    font-size: var(--sds-typography-scale-02);
    line-height: 1.5;
    color: var(--sds-color-text-default-secondary);
    margin: 0;
    font-style: italic;
  }

  .actions {
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: var(--sds-size-space-300);
    width: 100%;
  }

  .email-info {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-200);
    width: 100%;
  }

  .email-sent-text {
    font-family: var(--sds-typography-family-body);
    font-weight: var(--sds-typography-weight-regular);
    font-size: var(--sds-typography-scale-02);
    line-height: 1.5;
    color: var(--sds-color-text-default-inverse);
    margin: 0;
  }

  .spam-note {
    font-family: var(--sds-typography-family-body);
    font-weight: var(--sds-typography-weight-regular);
    font-size: var(--sds-typography-scale-01);
    line-height: 1.5;
    color: var(--sds-color-text-default-secondary);
    margin: 0;
  }

  .support-note {
    font-family: var(--sds-typography-family-body);
    font-weight: var(--sds-typography-weight-regular);
    font-size: var(--sds-typography-scale-01);
    line-height: 1.5;
    color: var(--sds-color-text-default-tertiary);
    margin: 0;
    margin-top: var(--sds-size-space-200);
    margin-right: auto;
  }

  .success-message {
    font-family: var(--sds-typography-family-body);
    font-weight: var(--sds-typography-weight-regular);
    font-size: var(--sds-typography-scale-02);
    line-height: 1.5;
    color: var(--sds-color-text-success-default);
    margin: 0;
  }

  .error-message {
    font-family: var(--sds-typography-family-body);
    font-weight: var(--sds-typography-weight-regular);
    font-size: var(--sds-typography-scale-02);
    line-height: 1.5;
    color: var(--sds-color-text-danger-default);
    margin: 0;
  }
`;
